/**
 * The render job of a saved estimate, as render-jobs.php?action=status
 * answers it (public/api/render-jobs-lib.php rj_status_payload).
 */

export type PictureId = 'user' | 'view1' | 'view2' | 'view3' | 'view4' | '360';

/** The strip's order: the user's own view, the four corners, the 360 last. */
export const PICTURE_ORDER: PictureId[] = ['user', 'view1', 'view2', 'view3', 'view4', '360'];

export type RenderJobStatus = 'awaiting-upload' | 'queued' | 'claimed' | 'rendering' | 'done' | 'failed';

export interface RenderJobPicture {
  id: PictureId;
  /** 1-based, of `count`. */
  index: number;
  count: number;
  name: string;
  percent: number;
}

export interface RenderJob {
  id: number;
  version: number;
  status: RenderJobStatus;
  /** 1 = next up; 0 when not queued. */
  queuePosition: number;
  queueAhead: number;
  percent: number;
  picture: RenderJobPicture | null;
  stage: 'downloading' | 'starting' | 'rendering' | 'uploading' | 'done' | null;
  etaSec: number | null;
  attempts: number;
  error: string | null;
  createdAt: string | null;
  startedAt: string | null;
  finishedAt: string | null;
}

export interface RenderPicture {
  id: PictureId;
  name: string;
  url: string | null;
  thumbUrl: string | null;
  width: number;
  height: number;
  done: boolean;
}

/** Where the 360 was taken from (room coordinates, feet: x along the length, y up, z along the width, the room's centre at 0,·,0). */
export interface PanoramaCamera {
  position: [number, number, number];
  target: [number, number, number] | null;
  face: string;
}

export interface RenderStatus {
  guid: string;
  job: RenderJob | null;
  /** Always the whole set the profile makes (placeholders for the ones not done). */
  pictures: RenderPicture[];
  /** The quick still taken in the designer, as its URL. */
  preview: string | null;
  panorama: PanoramaCamera | null;
  /** 0 = nothing more to wait for. */
  pollMs: number;
}
